import { GetCustomSummaryResults } from "@/graphql/queries/GetCustomSummaryResults";
import { useGraphQuery } from "@dashboard/library";

export const useGetCustomSummaryResults = (callId?: string | null) => {
  const result = useGraphQuery(GetCustomSummaryResults, {
    variables: { input: { callId: callId ?? "" } },
    skip: !callId,
  });

  return {
    ...result,
    customSummaryResult: result.output?.getCustomSummaryResults.items[0],
  };
};
